"use strict";

import angular from "angular";

import translationsEN from "./translations/en.json";
import translationsES from "./translations/es.json";
import { ENGLISH, SPANISH } from "../../app.constants";
import notificationSettings from "./components/notificationSettings";

let module = angular
    .module("common.notify", [])
    .component(notificationSettings.name, notificationSettings);
module.config(function ($translateProvider) {
    "ngInject";
    $translateProvider.translations(ENGLISH, translationsEN);
    $translateProvider.translations(SPANISH, translationsES);
    Object.entries(notificationSettings.translations).forEach(
        ([language, table]) => {
            $translateProvider.translations(language, table);
        },
    );
});

export default module;
